<ng-container *ngIf="!isLoggedIn()">{{ redirect() }}</ng-container>
<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
  <div class="collapse navbar-collapse" id="navbarNavDropdown">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item">
        <a class="nav-link" routerLink="/admins">Admins</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/admin" (click)="logout()">Log-out</a>
      </li>
    </ul>
  </div>
</nav>
<div ngbAccordion [closeOthers]="true" activeIds="static-1">
  <div ngbPanel id="static-1" title="Survey Details">
    <ng-template ngbPanelContent>
      <table class="table" id="details">
        <tbody>
          <tr>
            <th scope="row">Survey name</th>
            <td>{{ surveyDetails?.name }}</td>
          </tr>
          <tr>
            <th scope="row">Survey description</th>
            <td>{{ surveyDetails?.description }}</td>
          </tr>
          <tr>
            <th scope="row">Number of questions</th>
            <td>{{ surveyDetails?.questions.length }}</td>
          </tr>
          <tr>
            <th scope="row">Number of responses</th>
            <td>{{ respondents?.length }}</td>
          </tr>
          <tr>
            <th scope="row">Created on</th>
            <td>{{ surveyDetails?.created | date }}</td>
          </tr>
          <tr *ngIf="false">
            <th scope="row">Valid until</th>
            <td>{{ surveyDetails?.validTill | date }}</td>
          </tr>
        </tbody>
      </table>
    </ng-template>
  </div>
  <div ngbPanel *ngIf="false" id="static-2" title="View Responses">
    <ng-template ngbPanelContent>
      <div>
        <h6>Filter by Date</h6>
        <div class="form-group">
          <label for="startDate">
            Start Date
          </label>
          <input type="date" id="startDate" class="form-control" [ngModel]="filterStart"
            (ngModelChange)="filterStart = $event">
        </div>
        <div class="form-group">
          <label for="endDate">
            End Date
          </label>
          <input type="date" id="endDate" class="form-control" [ngModel]="filterEnd"
            (ngModelChange)="filterEnd = $event">
          <div class="form-group">
            <button (click)="filterByDate()" class="btn btn-info">Filter</button>
          </div>
        </div>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Response id</th>
            <th scope="col">Submission Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let respondent of respondents;let i=index">
            <th scope="row">{{i+1}}</th>
            <td>{{respondent.fullName}}</td>
            <td>{{respondent.takenOn | date }}</td>
          </tr>
        </tbody>
      </table>
    </ng-template>
  </div>
  <div ngbPanel id="static-3" title="Export Responses">
    <ng-template ngbPanelContent>
      <h5 *ngIf="false">Export Respondents</h5>
      <div *ngIf="false" class="row pad-left">
        <button *ngIf="false" class="btn btn-info col-sm-2" (click)="downloadCsv('respondents')">csv</button>
        <button *ngIf="false" class="btn btn-info col-sm-2 offset-sm-1" (click)="downloadXlsx('respondents')">excel</button>
        <button *ngIf="false" class="btn btn-info col-sm-2 offset-sm-1" (click)="downloadJson('respondents')">json</button>
      </div>
      <br *ngIf="false">
      <h5>Export Responses</h5>
      <div class="row pad-left">
        <button class="btn btn-info col-sm-2" (click)="downloadCsv('responses')">csv</button>
        <button class="btn btn-info col-sm-2 offset-sm-1" (click)="downloadXlsx('responses')">excel</button>
        <button *ngIf="false" class="btn btn-info col-sm-2 offset-sm-1" (click)="downloadJson('responses')">json</button>
      </div>
    </ng-template>
  </div>
</div>
